import { ArrowHeadDown, ArrowHeadUp } from "@/assets";
import { Button, FilterCommon, HistoryModal, ImportModal, Table } from "@/components";
import {
  CREATE_TYPE,
  filtersJson,
  HISTORY_TYPE,
  policyManagementDepartmentColumns,
  POLICY_MANAGEMENT_DEPARTMENT_SCREEN,
  ROUTER_PAGE_POLICY_CONFIG_CREATE,
  TMS_ROLE_ADMIN,
  TMS_ROLE_HR,
  TMS_ROLE_HRM,
} from "@/utils";
import PolicyManagementEmployeeModal from "@/components/PolicyManagement/PolicyManagementEmployeeModal/PolicyManagementEmployeeModal.vue";
import { mapState } from "vuex";

const dataSources = [
  {
    id: 1,
    department: "TDX DEPT",
    workScheduleCode: "GLB_FLEX_8H00_9H30_6 HOURS",
    workScheduleType: "Flexible",
    time: "08:30 - 17:30",
    workingTime: "8.00 hour(s)",
    explanationRule: "03 times/ payroll period, 02 hours/ time, 01 time/ day",
    dateApplied: "01/06/2022",
    dateExpired: "01/06/2022",
  },
  {
    id: 2,
    department: "IT DEPT",
    workScheduleCode: "GLB_FLEX_8H00_9H30_6 HOURS",
    workScheduleType: "Flexible",
    time: "08:30 - 17:30",
    workingTime: "8.00 hour(s)",
    explanationRule: "03 times/ payroll period, 02 hours/ time, 01 time/ day",
    dateApplied: "01/06/2022",
    dateExpired: "01/06/2022",
  },
];

const actions = [
  {
    key: "history",
    value: "history",
    title: "History",
  },
  {
    key: "edit",
    value: "edit",
    title: "Edit",
  },
  {
    key: "remove",
    value: "remove",
    title: "Remove",
  },
];

const moreFilters = [
  {
    key: "project",
    value: "project",
    label: "Project",
  },
  {
    key: "onboardDate",
    value: "onboardDate",
    label: "Onboard Date Range",
  },
];
export default {
  name: "PolicyManagementDepartment",
  components: {
    FilterCommon,
    Button,
    Table,
    PolicyManagementEmployeeModal,
    ImportModal,
    HistoryModal,
  },
  data() {
    return {
      columns: policyManagementDepartmentColumns,
      POLICY_MANAGEMENT_DEPARTMENT_SCREEN,
      pages: {
        page: 1,
        size: 10,
        total: 0,
      },
      dataFilterDefault: {},
      dataSources,
      actions,
      visibleMoreFilter: false,
      ArrowHeadDown,
      ArrowHeadUp,
      filtersJson,
      filterListOrigin: filtersJson[POLICY_MANAGEMENT_DEPARTMENT_SCREEN] ?? [],
      filterList: [],
      moreFilters,
      moreFiltersValueOld: [],
      moreFiltersValue: [],
      visibleModal: false,
      visibleModalImport: false,
      visibleModalHistory: false,
      type: null,
      activeRecord: null,
      loadingDownload: false,
      isApplied: false,
    };
  },
  watch: {
    visibleMoreFilter(newValue) {
      if (newValue && !this.isApplied) {
        this.moreFiltersValue = [...this.moreFiltersValueOld];
      }
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
    checkShowAction() {
      const {
        userInfo: { roles },
      } = this;
      return roles?.some((role) => [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN].includes(role));
    },
  },
  created() {
    this.filterList = this.filterListOrigin.filter((filterItem) => !filterItem.isHide);
  },
  mounted() {
    let _this = this;
    window.addEventListener("click", function () {
      _this.visibleMoreFilter = false;
    });
  },
  destroyed() {
    window.removeEventListener("click");
  },
  methods: {
    handleFilter() {},
    handleAddNew() {
      this.$router.push({ name: ROUTER_PAGE_POLICY_CONFIG_CREATE });
    },
    onAction({ type, data }) {
      this.type = type;
      this.activeRecord = data;
      switch (type) {
        case HISTORY_TYPE: {
          this.visibleModalHistory = true;
          break;
        }
        default: {
          this.visibleModal = true;
        }
      }
    },
    handleChangePagination() {},
    onChangeMoreFilters(checkedValue) {
      this.moreFiltersValue = checkedValue;
      this.isApplied = false;
    },
    handleMoreFilters() {
      this.visibleMoreFilter = !this.visibleMoreFilter;
    },
    handleClearMoreFilter() {
      this.moreFiltersValue = [];
    },
    handleCancelMoreFilters() {
      this.visibleMoreFilter = false;
    },
    handleApplyMoreFilters() {
      this.filterList = this.filterListOrigin.filter(
        ({ isHide, name }) => !isHide || this.moreFiltersValue.includes(name)
      );
      this.moreFiltersValueOld = [...this.moreFiltersValue];
      this.isApplied = true;
    },
    handleSetPolicy() {
      this.type = CREATE_TYPE;
      this.visibleModal = true;
    },
    handleImport() {
      this.visibleModalImport = true;
    },
    onImport() {},
    downloadTemplate() {},
    onCancel() {
      this.visibleModal = false;
      this.visibleModalHistory = false;
      this.visibleModalImport = false;
    },
  },
};
